/****************************************************
 * Module Name:  memoComponent.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Menu, styled, alpha, Tooltip, Typography, MenuItem, Switch, Stack, Badge, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, createTheme } from "@mui/material";
import QRcode from "react-qr-code";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MemoProxy from "../../utility/proxy/manager/memoProxy";
import Constants from "../../utility/constants";
import MemostatusProxy from "../../utility/proxy/manager/memostatusProxy";
import StoneDetailModal from "../common/stoneDetailModal";
import { LoadingButton } from "@mui/lab";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import TotalStockComponent from "../common/totalStockComponent";
import { BsFilePdf } from "react-icons/bs";
import 'bootstrap/dist/css/bootstrap.min.css';
import PDFModal from '../common/pdfModal';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import colourchart from '../../images/ColorScheme.png'
import CancelIcon from '@mui/icons-material/Cancel';
import CloseMemoModal from "../sales/closeMemoModal";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import MemoIssue from "../operations/memoIssue";
import { Modal } from "react-bootstrap";
import logo from '../../images/pansuriya.jpg'
import DiamondIcon from '@mui/icons-material/Diamond';
import PageTitle from "./pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const innerTableStyleCSS = {
    '& .MuiDataGrid-columnHeader': {
        color: '#fff',
        backgroundColor: 'grey',
    },
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
        py: "4px",
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
        py: "12px",
    },
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
        py: "18px",
    },
    // bgcolor: "#cfd8dc",
    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
    "& .super-app-theme--NEW": {
        backgroundColor: "#F9F08D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F9F08D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LAB": {
        backgroundColor: "#7EAEEE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#7EAEEE",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
            color: "black",
        },
    },
    "& .super-app-theme--RE-LAB": {
        backgroundColor: "#FCCD91",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FCCD91",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK": {
        backgroundColor: "#FFFFCC",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FFFFCC",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_SENT": {
        backgroundColor: "#B8ACF6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B8ACF6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--RE-CHECK_DONE": {
        backgroundColor: "#388BFF",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#388BFF",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MIX": {
        backgroundColor: "#E0E88C",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#E0E88C",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE_APPROVAL_PENDING": {
        backgroundColor: "#FBDEDE",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FBDEDE",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--AVAILABLE": {
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--HOLD": {
        backgroundColor: "#B6B9D6",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#B6B9D6",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--MEMO_OUT": {
        backgroundColor: "#CAF7F6",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CAF7F6",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL": {
        backgroundColor: "#CCFF99",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#CCFF99",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_SENT": {
        backgroundColor: "#F797D2",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F797D2",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SOLD": {
        backgroundColor: "#26D4B9",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#26D4B9",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--SELL_CANCELLED": {
        backgroundColor: "#F59598",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#F59598",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
    "& .super-app-theme--LOCATION_SENT": {
        backgroundColor: "#FEBD7D",
        color: "black",
        fontSize: Constants.defaultTableFontSize,
        fontWeight: Constants.defaultFontWeight,
        "&:hover": {
            backgroundColor: "#FEBD7D",
            color: "black",
            fontSize: Constants.defaultTableFontSize,
            fontWeight: Constants.defaultFontWeight,
        },
    },
}

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

const MemoComponent = ({
    isReport,
    hasPermission,
}) => {
    const [status, setStatus] = useState([]);
    const [statusOption, setStatusOption] = useState([]);
    const [listData, setListData] = useState([]);
    const [mainData, setMainData] = useState([]);
    // const [expandedRowIds, setExpandedRowIds] = useState([]);
    const [memoLoader, setMemoLoader] = useState(false);
    const [fetchData, setFetchData] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [stoneId, setStoneId] = useState(0);
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const defaultOptions = { value: "*", label: "-- ANY --" };
    const [customerData, setCustomerData] = useState({
        customer: [],
        customerOptions: [],
    });
    const [columnNames, setColumnNames] = React.useState([]);

    const [local_Permission] = useState(hasPermission);

    const [pdfName, setPdfName] = useState("");
    const [pdfByte, setPdfByte] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [show, setShow] = useState(false);
    const [memoId, setMemoId] = useState([]);
    const [closeMemoModalTitle, setCloseMemoModalTitle] = useState("");
    const [loadingCloseMemoButton, setLoadingCloseMemoButton] = useState(false);
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [infoMessage, setInfoMessage] = useState("");
    const [showInfoSnackbar, setShowInfoSnackbar] = useState(false);
    const [locationData, setLocationData] = useState({
        location: "",
        locationOptions: [],
    });

    const [openIssueModal, setOpenIssueModal] = useState(false);

    const [fetchCount, setFetchCount] = useState(0);
    const [groupBy, setGroupBy] = useState(true);
    const [filterValues, setFilterValues] = useState({});
    const [showUserDetailModal, setShowUserDetailModal] = useState(false);
    const [userIds, setUserIds] = useState([]);
    // const [visibleRowLimit, setVisibleRowLimit] = useState(0);
    // eslint-disable-next-line
    const [memoIssue_Permission, setMemoIssue_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEMO_ISSUE
        )
    );

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Function to control which rows are expanded
    // const handleRowExpansion = () => {
    //     const rowIdsToExpand = mainData.slice(0, visibleRowLimit).map(row => row.id);
    //     setExpandedRowIds(rowIdsToExpand);
    // };

    // const handleRowsScrollEnd = () => {
    //     setVisibleRowLimit((prevLimit) => prevLimit + 2);
    // };

    // const expandedIdsChange = (expandedRowIds) => {
    //     setExpandedRowIds(expandedRowIds);
    // }

    // useEffect(() => {
    //     if (mainData.length > 0) {
    //         handleRowExpansion();
    //     }
    // }, [mainData, visibleRowLimit]);

    useEffect(() => {
        PageTitle("OPERATION_MEMO");
        getAllStatusData();
        if (isReport) {
            getAllLocationData();
        }
    }, []);

    useEffect(() => {
        if (locationData.location !== "" || !isReport) {
            getAllCustomerData();
        }
    }, [locationData.location,])

    const getAllCustomerData = () => {

        let status = ["NEW", "INPROGRESS", "CLOSED"];
        MemoProxy.GetCustomersCreatedMemo(

            //the first consition will only fail when the call is from oprn/memo tab  so else part is to handle that condition
            isReport ? locationData.location.value : local_Permission ? Constants.loggedInUser.locationid : -1, //if permission show memo of only that location else of all location
            local_Permission ? -1 : Constants.loggedInUser.id, //if permission show memo created for all the customers else for all such customers which are attached to the logged in employee/broker/customer(himself)
            Constants.loggedInUser.usertype, status, (response) => {
                if (response) {
                    prepareUserData(response);
                }
            });
    };

    const prepareUserData = (response) => {

        let optionsArray = [];
        optionsArray.push(defaultOptions);
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.companyname,
            };
            optionsArray.push(option);
            return true;
        });
        setUserIds(optionsArray.filter(option => option.value !== "*").map(option => option.value));
        setCustomerData({
            customerOptions: optionsArray,
            customer: optionsArray.length > 0 ? [optionsArray[0]] : []
        });

        /* as we use this component for two screens, in memoReport screen, we need to fetch customers for every location diffrently,
         at that time we need to just fetch the records once at the time of page load */
        setFetchCount(fetchCount => fetchCount + 1);

        setFetchData(true);
        return true;
    };

    const getAllLocationData = () => {
        LocationProxy.GetAllLocationDetailMini((response) => {
            setDataLocation(response);
        });
    };

    const setDataLocation = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.name + " | " + data.country };
            optionsArray.push(option);
            return true;
        });
        setLocationData({
            ...locationData,
            locationOptions: optionsArray,
            location:
                locationData.location === "" && optionsArray.length > 0
                    ? optionsArray.find(data => data.value === Constants.loggedInUser.locationid)
                    : locationData.location,
        });
    };

    const fullOptionToValue = (selectedData, mainData) => {
        let newArr = [];
        selectedData.map((data) => {
            if (data.value === "*") {
                return (mainData.map((option) => {
                    if (option.value !== "*") {
                        newArr.push(option.value);
                        return true;
                    }
                    return true;
                })).join(",");
            }
            return true;
        })
        return Utility.GetValueArrayWithStarReplace(selectedData, newArr).join(",");
    };

    useEffect(() => {
        if (fetchData) {
            if (status.length !== 0 && (customerData.customer !== "" || local_Permission) && !(isReport && !(locationData.location !== "")) && fetchCount === 1) {
                handleSearch(status);
            }
        }
    }, [fetchData, status]);

    const getAllStatusData = () => {
        MemostatusProxy.GetAllMemostatusMini((response) =>
            setAllStatusData(response)
        );
    };

    const setAllStatusData = (response) => {
        let optionsArray = [];
        let selectedOption = [];
        optionsArray.push(defaultOptions);
        response.map((data) => {
            let option = { value: data.status, label: data.status };
            if (data.status === "NEW" || data.status === "INPROGRESS") {
                selectedOption.push(option);
            }
            optionsArray.push(option);
            return true;
        });

        setStatusOption(optionsArray);
        setStatus(selectedOption);
    };

    const handleCloseMemo = (id, message) => {
        setLoadingCloseMemoButton(true);
        MemoProxy.CloseMemo(id, (response) => {
            if (response) {
                setShow(false);
                handleSearch(status);
                setShowSuccessSnackbar(true);
                setSuccessMessage(message);
                setSnackbarVariant("success");
                setLoadingCloseMemoButton(false);
            } else {
                setShowSuccessSnackbar(true);
                setSuccessMessage(Constants.APiFailErrorMessage);
                setSnackbarVariant("error");
                setLoadingCloseMemoButton(false);
            }
        });
    };

    const handleSearch = (status) => {
        let statuss = "";
        let selectedCustomers = Constants.loggedInUser.usertype === "C" ? Constants.loggedInUser.id.toString() : fullOptionToValue(customerData.customer, customerData.customerOptions);
        statuss = fullOptionToValue(status, statusOption);

        if (selectedCustomers !== undefined && selectedCustomers !== "") {
            setMemoLoader(true);
            MemoProxy.GetMemosForUserByPermissionAndLocation(
                isReport ? locationData.location.value : local_Permission ? Constants.loggedInUser.locationid : -1,
                Constants.loggedInUser.usertype,
                local_Permission ? -1 : Constants.loggedInUser.id,
                statuss,
                selectedCustomers === "" ? " " : selectedCustomers,
                (response) => {
                    if (response) {
                        const uniqueFilterValues = {
                            customer: Utility.getDistinctOptions(response, "customerid"),
                            status: Utility.getDistinctOptions(response, "status"),
                            createdby: Utility.getDistinctOptions(response, "username"),
                        };
                        const combinedFilterValues = {
                            status: uniqueFilterValues.status,
                            createdby: uniqueFilterValues.createdby,
                            customer: uniqueFilterValues.customer.map(value => {
                                const matchingItem = response.find(item => item.customerid === value);
                                return matchingItem ? `${value} | ${matchingItem.customercompanyname}` : [];
                            }),
                        };

                        response.map(row => {
                            const today = new Date();
                            const nDaysAgo = new Date(today);
                            nDaysAgo.setDate(today.getDate() - Constants.NEW_STONE_DAYS);
                            const referenceDate = row.age ? new Date(row.age) : row.stonecreatedat ? new Date(row.stonecreatedat) : null;
                            row.isNew = referenceDate ? referenceDate > nDaysAgo : false;
                            return true;
                        });

                        setFilterValues(combinedFilterValues);
                        setListData([]);
                        setListData(response);
                        handleArray(response);
                        setMemoLoader(false);
                        setFetchData(false);
                        const distinctStatus = Utility.getDistinctOptions(response, 'stonestatus');
                        prepareColumns(distinctStatus);
                    } else {
                        setMemoLoader(false);
                        setErrorSnackbar(true);
                    }
                }
            );
        } else {
            setListData([]);
            setMainData([]);
            setShowInfoSnackbar(true);
            setInfoMessage("No memos have been created for your attached customer at this time.");
            setSnackbarVariant("info");
        }
    };

    const downloadPDF = (locationId, memoId) => {
        MemoProxy.getMemoPDF(locationId, memoId, (res) => {
            if (res) {
                setPdfByte(res.fileBytes);
                setPdfName(`Memo_` + memoId + `.pdf`);
            }
        })
        openModal()
    }

    const handleArray = (lListData) => {
        let listIdTracker = 0;
        let newMainData = [];
        if (lListData.length > 0) {
            lListData.map((list) => {
                if (listIdTracker === 0 || list.memoid !== listIdTracker) {
                    listIdTracker = list.memoid;
                    newMainData.push({
                        id: list.memoid,
                        createdat: list.createdat,
                        createdby: list.username,
                        customerusername: list.customerusername,
                        customerid: list.customerid,
                        createdbyid: list.userid,
                        status: list.status,
                        memomasterremark: list.memomasterremark,
                        customercompanyname: list.customercompanyname
                    });
                }
                return true;
            });
        }
        setMainData(newMainData);
    };

    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };

    const handleClose = () => {
        setShowStoneDetailModal(false);
    };

    const handleCloseMemoIssueModal = (message, ws) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            ws.close();
        }

        setOpenIssueModal(false);
        if (message !== undefined && message !== "") {
            setShowSuccessSnackbar(true)
            setSuccessMessage(message)
            setSnackbarVariant("success")
            handleSearch(status);
        }
    };
    const rows = Utility.GenerateUniqueIdOfResponseForDataGrid(listData);

    const columnData = {
        "8eaa8a03-d163-436d-8912-51ea06306f44": {
            field: "certificateid",
            headerName: "CERT",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },
        "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
            field: "shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 80,
            renderCell: renderCellExpand,
        },
        "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
            field: "stoneid",
            headerName: "STONEID",
            headerAlign: "center",
            align: "center",
            type: "number",
            width: 110,
            renderCell: (params) => {
                const isNew = params.row.isNew;
                const shouldShowModal = Utility.NeedToShowStoneDetailModal();
                if (isNew) {
                    return (
                        <Box
                            sx={{
                                "& .MuiBadge-badge": {
                                    height: "0.75rem !important",
                                    padding: "2px 4px !important",
                                    fontSize: "10px",
                                    top: "9px",
                                    backgroundColor: "#E0FBE2 !important",
                                    color: "#059212 !important",
                                },
                            }}
                        >
                            <Badge
                                badgeContent={"NEW"}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                <Button
                                    sx={{
                                        textDecorationLine: "underline",
                                        color: "black",
                                    }}
                                    onClick={() => handleStoneDetailModal(params)}
                                >
                                    {params.value}
                                </Button>
                            </Badge>
                        </Box>
                    );
                }

                if (shouldShowModal) {
                    return (
                        <Button
                            sx={{
                                textDecorationLine: "underline",
                                color: "black",
                            }}
                            onClick={() => handleStoneDetailModal(params)}
                        >
                            {params.value}
                        </Button>
                    );
                }

                return <div>{params.value}</div>;
            },
        },
        "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
            field: "stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
        },
        "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
            field: "stonestatus",
            headerName: "STONE STATUS",
            headerAlign: "center",
            align: "center",
            width: 150,
            renderCell: (params) => params.value === "HOLD" ? (
                <span style={{ fontSize: "14px" }}>
                    <b>{params.value}</b>{
                        params.row.memodetailsubstatus === "MEMO_OUT" ? (<>&nbsp;|&nbsp;MEMO_OUT</>) :
                            (params.row.stonelabdetailstatus === "REPORT_RECEIVED" ? (<>&nbsp;|&nbsp;LAB</>) : null)
                    }
                </span>
            ) : (params.row.stonelabdetailstatus === "REPORT_RECEIVED" ? "LAB" : params.value),
            cellClassName: (params) => params.row.stonelabdetailstatus === "REPORT_RECEIVED" ? "greenCell" : `super-app-theme--${params.row.stonestatus.toUpperCase()}`,
        },
        "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "right",
            type: "number",
            width: 40,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size),
        },
        "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
            field: "color",
            headerName: "COLOR",
            headerAlign: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "center",
            width: 65,
            renderCell: renderCellExpand,
        },
        "d4992de9-92ab-4f9e-ba12-6c746e935611": {
            field: "colordescriptions",
            headerName: "COLOR DESCRIPTIONS",
            headerAlign: "center",
            align: "center",
            width: 160,
            renderCell: renderCellExpand,
        },
        "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
            field: "clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 75,
            renderCell: renderCellExpand,
        },
        "3597803f-8932-40c6-8de6-81006f4d6d5b": {
            field: "cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 50,
            renderCell: renderCellExpand,
        },
        "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
            field: "pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        "5541c182-21b8-496e-b342-b0b89f3d302f": {
            field: "sym",
            headerName: "SYM",
            headerAlign: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "center",
            width: 40,
            renderCell: renderCellExpand,
        },
        "8296e627-0be5-4a66-830f-ea6867cea137": {
            field: "flo",
            headerName: "FLO",
            headerAlign: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "center",
            width: 60,
            renderCell: renderCellExpand,
        },
        "798a8663-0f0c-41be-8512-16dd60d5f25e": {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            type: "number",
            align: "center",
            width: 50,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
        },
        "53c8a138-3f8e-486c-a9ba-f5c671065ad7": {
            field: "rapnetprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "center",
            type: "number",
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.rapnetprice)
        },
        "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
            field: "lab",
            headerName: "LAB",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            width: 40,
            renderCell: renderCellExpand,
        },
        "ab3e506e-bddb-456d-b967-922dcee74d56": {
            field: "location",
            headerName: "LOCATION",
            headerAlign: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            align: "left",
            width: 130,
            renderCell: (params) => params.row.stoneoldstatus === null ? params.value : (
                <Box
                    sx={{
                        "& .MuiBadge-badge": {
                            height: "0.75rem !important",
                            padding: "2px 4px !important",
                            fontSize: "8px",
                            top: "-1px",
                            right: "-20px",
                            backgroundColor: "#E5D9F2 !important",
                            color: "#624E88 !important",
                            fontWeight: "700"
                        },
                    }}
                >
                    <Badge
                        badgeContent={"TRANSIT"}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {params.value}
                    </Badge>
                </Box>
            ),
        },
        "39c634f1-2644-4307-acbb-983b4de4229e": {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            type: "number",
            width: 70,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
        },
        "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
            field: "total",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            width: 70,
            type: "number",
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
        },
    };

    const prepareColumns = (distinctStatus) => {
        let columnNames = [];

        Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
            if (columnData.hasOwnProperty(iColPermission)) {
                const columnsData = columnData[iColPermission];
                if (columnsData.field === "stonestatus") {
                    columnsData.type = "singleSelect";
                    columnsData.valueOptions = distinctStatus;
                    columnsData.filterOperators = Utility.combinedFilters();
                }
                columnNames.push(columnsData);
                if (columnsData.field === "stoneid") {
                    columnNames.push({
                        field: "memodetailstatus",
                        headerName: "STATUS",
                        headerAlign: "center",
                        align: "center",
                        width: 100,
                        renderCell: renderCellExpand,
                    })
                }
            }
        })

        columnNames.push({
            field: "lastupdatedat",
            headerName: "LAST UPDATED",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        });
        columnNames.push({
            field: "expectedreceive",
            headerName: "EXPECTED RECEIVE",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        });
        columnNames.push({
            field: "updatedat",
            headerName: "UPDATED",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        });
        columnNames.push({
            field: "givenat",
            headerName: "GIVEN",
            headerAlign: "center",
            align: "center",
            width: 150,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        });

        setColumnNames(columnNames);
    }

    const columns = columnNames;
    const defaultMaterialTheme = createTheme();

    // Color Scheme Drop Down Button
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseButton = () => {
        setAnchorEl(null);
    };

    const ColumnJson = [
        {
            headerName: "CLOSE MEMO",
            field: "closememo",
            export: false,
            headerAlign: "center",
            align: "center",
            width: 150,
            renderCell: (params) => (
                <Tooltip title="Close Memo">
                    <Button
                        variant="contained"
                        component="label"
                        size="small"
                        startIcon={<CancelIcon size="large" />}
                        color="primary"
                        disabled={params.row.status !== "NEW"}
                        onClick={(e) => {
                            e.stopPropagation()
                            setShow(true);
                            setMemoId(params.row.id);
                            setCloseMemoModalTitle(
                                "Are you sure you want to Close this Memo ?"
                            );
                        }}
                        sx={{
                            "& .Mui-disabled": {
                                backgroundColor: "#eaeaea !important",
                                color: "#c0c0c0 !important",
                                "&:hover": {
                                    backgroundColor: "none !important",
                                },
                            }
                        }}
                    >
                        CLOSE
                    </Button>
                </Tooltip>
            ),
        },
        {
            headerName: "ISSUE",
            field: "issuememo",
            export: false,
            headerAlign: "center",
            align: "center",
            width: 150,
            renderCell: (params) => (
                <Tooltip title="Issue Memo">
                    <Button
                        variant="contained"
                        component="label"
                        size="small"
                        startIcon={<DiamondIcon fontSize="small" />}
                        color="primary"
                        disabled={!(params.row.status === "NEW" && memoIssue_Permission.length > 0)}
                        onClick={(e) => {
                            setMemoId(params.row.id);
                            setOpenIssueModal(true);
                        }}
                        sx={{
                            "& .Mui-disabled": {
                                backgroundColor: "#eaeaea !important",
                                color: "#c0c0c0 !important",
                                "&:hover": {
                                    backgroundColor: "none !important",
                                },
                            }
                        }}
                    >
                        ISSUE
                    </Button>
                </Tooltip>
            ),
        },
        {
            headerName: "MEMO ID",
            field: "id",
            defaultSort: "desc",
            headerAlign: "center",
            type: "number",
            align: "center",
            width: 100,
            renderCell: renderCellExpand,
        },

        {
            headerName: "STATUS",
            field: "status",
            headerAlign: "center",
            align: "center",
            width: 180,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.status : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            headerName: "CREATED AT",
            field: "createdat",
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => {
                if (params.value) {
                    return Utility.ConvertUtcToLocalTime(params.value);
                } else {
                    return "";
                }
            },
            headerAlign: "center",
            align: "center",
            width: 200,
        },
        {
            headerName: "CREATED BY",
            field: "createdby",
            headerAlign: "center",
            align: "center",
            width: 200,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.createdby : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            headerName: "CUSTOMER COMPANY",
            field: "customercompanyname",
            headerAlign: "center",
            align: "center",
            width: 250,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customer : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.customerid} | ${params.row.customercompanyname}`;
            },
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {`${params.row.customerid} | ${params.row.customercompanyname}`}
                    </span>
                </div>
            ),
        },
        {
            headerName: "USER ID",
            field: "createdbyid",
            headerAlign: "center",
            type: "number",
            align: "center",
            width: 150,
            renderCell: renderCellExpand,
        },
        {
            headerName: "MEMO REMARK",
            field: "memomasterremark",
            headerAlign: "center",
            align: "center",
            width: 150,
        },
        {
            field: "pdf",
            headerName: "PDF",
            renderCell: (params) => {
                if (params.row.status !== "INPROGRESS") {
                    return "No PDF"
                } else {
                    return <BsFilePdf size={25} color="red" onClick={() => downloadPDF(Constants.loggedInUser.locationid, params.row.id)} />
                }
            },
            headerAlign: "center",
            export: false,
            align: "center",
            width: 150,
        },
    ];


    const getDetailPanelHeight = React.useCallback((row) => {
        const stonesInRow = listData.filter((data) => data.id === row.id).length;

        // Calculate height based on the number of stones
        if (stonesInRow <= 3) {
            return 290;
        } else if (stonesInRow <= 6) {
            return 350;
        } else {
            return 515;
        }
    }, [listData]);

    const getDetailPanelContent = React.useMemo(
        () => (row, listData) => <DetailPanelContent row={row} listData={listData} />,
        [columns, listData]  // Memoizing based on columns and listData
    );

    function DetailPanelContent({ row: rowProp, listData }) {
        let rows = listData
            .filter((data) => data.id === rowProp.id)
            .sort((a, b) => a.stoneid - b.stoneid);

        let qrValue = window.btoa(
            JSON.stringify({
                userid: rowProp.createdbyid,
                memoid: rowProp.id,
            })
        );
        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        color: '#000',
                        width: "100%",
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        display: "flex",
                        minHeight: "20vh",
                        maxHeight: "90vh",
                        "& .greenCell": {
                            backgroundColor: "#B5DB53"
                        },
                        height: 'auto',
                        marginLeft: '16px',
                    }}
                >
                    <DataGridPro
                        disableRowSelectionOnClick={false}
                        density="compact"
                        sx={innerTableStyleCSS}
                        columns={columns}
                        rows={rows}
                        getRowId={(row) => row.stoneid}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: Constants.pageSize,
                            },
                        }}
                        pageSizeOptions={Constants.pageSizeOptions}
                        pagination
                    />
                    <Box
                        sx={{
                            textAlign: "center",
                            height: "auto",
                            // margin: "auto",
                            maxWidth: 174,
                            width: "20%",
                            padding: "10px",
                        }}
                    >
                        <QRcode
                            value={qrValue}
                            fgColor="#03a9f4"
                            style={{
                                height: "100px",
                                maxWidth: "100%",
                                width: "85%",
                            }}
                        />
                    </Box>
                </Box>
            </Stack>
        );
    }

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />

                {groupBy && (
                    <>
                        {memoLoader ? (
                            <CircularProgress size="1rem" />
                        ) : (
                            <Tooltip title="Reload List">
                                <RefreshOutlinedIcon
                                    onClick={() => {
                                        setFetchCount(0);
                                        getAllCustomerData();
                                    }
                                    }
                                    color="primary"
                                    fontSize="medium"
                                    sx={{ cursor: "pointer" }}
                                />
                            </Tooltip>
                        )}
                    </>
                )}
                {!groupBy && (
                    <>
                        {memoLoader ? (
                            <CircularProgress size="1rem" />
                        ) : (
                            <Tooltip title="Reload List">
                                <RefreshOutlinedIcon
                                    onClick={() =>
                                        handleSearch(locationData.location, status)
                                    }
                                    color="primary"
                                    fontSize="medium"
                                    sx={{ cursor: "pointer" }}
                                />
                            </Tooltip>
                        )}
                    </>
                )}
                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    }


    return (
        <div>
            <div>
                <TabMenuSnackbar
                    show={errorSnackbar}
                    message={Constants.APiFailErrorMessage}
                    variant={"error"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Failed"}
                    handleClose={() => setErrorSnackbar(false)}
                />
                <TabMenuSnackbar
                    show={showSuccessSnackbar}
                    message={successMessage}
                    variant={snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Success"}
                    handleClose={() => setShowSuccessSnackbar(false)}
                />
                <TabMenuSnackbar
                    show={showInfoSnackbar}
                    message={infoMessage}
                    variant={snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Info"}
                    handleClose={() => setShowInfoSnackbar(false)}
                />
                {showStoneDetailModal ? (
                    <StoneDetailModal
                        show={showStoneDetailModal}
                        stoneId={stoneId}
                        handleClose={handleClose}
                    />
                ) : null}

                {openIssueModal ? (
                    <Modal
                        show={openIssueModal}
                        onHide={handleCloseMemoIssueModal}
                        dialogClassName="max-modalSize"
                        enforceFocus={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <img
                                    src={logo}
                                    height="40pt"
                                    width="40pt"
                                    alt={Constants.COMPANY_SITE}
                                />
                                &nbsp;&nbsp;
                                MEMO ISSUE
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <MemoIssue
                                showModal={openIssueModal}
                                memoid={memoId}
                                closeModal={handleCloseMemoIssueModal}
                            />
                        </Modal.Body>
                    </Modal>
                ) : null
                }

                {
                    show ? (
                        <CloseMemoModal
                            show={show}
                            setShow={setShow}
                            handleSave={handleCloseMemo}
                            memoid={memoId}
                            closeMemoModalTitle={closeMemoModalTitle}
                            loading={loadingCloseMemoButton}
                        />
                    ) : null
                }
                {showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => setShowUserDetailModal(false)}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = customerData.customerOptions.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            setCustomerData({ ...customerData, customer: selectedCustomers, });
                            setShowUserDetailModal(false)
                        }}
                        userids={userIds}
                        selectedIds={customerData.customer.length !== 0 ? customerData.customer.map(iCustomer => iCustomer.value) : []}
                        usertype={"C"}
                        loading={showUserDetailModal}
                        isMulti={true}
                    />
                ) : null}
                {/*need to send pdf in byte string to modal */}
                <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />
            </div>

            <Box>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        margin: "5px 0",
                        flexWrap: "wrap",
                    }}
                >
                    {isReport && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography>Location</Typography>
                            <Box sx={{ minWidth: { xs: "100%", sm: "15vw" } }}>
                                <Select
                                    menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={locationData.location}
                                    isSearchable={true}
                                    name="location"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...Constants.Styles,
                                        container: (base) => ({
                                            ...base,
                                            minWidth: "100%",
                                        }),
                                    }}
                                    options={locationData.locationOptions}
                                    onChange={(selectedOption) =>
                                        setLocationData({
                                            ...locationData,
                                            location: selectedOption,
                                        })
                                    }
                                />
                            </Box>
                        </Box>
                    )}

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                        <Typography>
                            Customer Company{" "}
                            {Constants.loggedInUser.usertype !== "C" ? "" : " :- "}
                        </Typography>

                        {Constants.loggedInUser.usertype !== "C" ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    minWidth: { xs: "100%", sm: "15vw" },
                                }}
                            >
                                <Select
                                    menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    isMulti
                                    className="basic-single"
                                    classNamePrefix="select"
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    value={customerData.customer}
                                    isSearchable={true}
                                    name="Customer"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...Constants.Styles,
                                        container: (base) => ({
                                            ...base,
                                            minWidth: "100%",
                                        }),
                                    }}
                                    options={customerData.customerOptions}
                                    onChange={(selectedOption) =>
                                        setCustomerData({
                                            ...customerData,
                                            customer: selectedOption,
                                        })
                                    }
                                />
                                <Tooltip title="View More Data">
                                    <OpenInNewIcon
                                        sx={{ cursor: "pointer" }}
                                        fontSize="medium"
                                        color="action"
                                        onClick={() => setShowUserDetailModal(true)}
                                    />
                                </Tooltip>
                            </Box>
                        ) : (
                            <Typography
                                fontWeight={Constants.defaultFontWeightBold}
                                variant="h6"
                            >
                                {Constants.loggedInUser.companyname}
                            </Typography>
                        )}
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", marginLeft: "30px" }}>
                        <Typography>Status</Typography>
                        <Box sx={{ minWidth: { xs: "100%", sm: "15vw" } }}>
                            <Select
                                menuPlacement="auto"
                                blurInputOnSelect={false}
                                menuPortalTarget={document.body}
                                styles={{
                                    ...Constants.Styles,
                                    container: (base) => ({
                                        ...base,
                                        minWidth: "100%",
                                    }),
                                }}
                                closeMenuOnSelect={false}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                isMulti
                                options={statusOption}
                                value={status}
                                onChange={(e) => setStatus(e)}
                            />
                        </Box>
                    </Box>

                    {isReport && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Switch
                                disabled={memoLoader}
                                checked={groupBy}
                                onChange={() => setGroupBy(!groupBy)}
                                color="primary"
                                inputProps={{ "aria-label": "Group By toggle" }}
                            />
                            <Typography variant="body1">Group By</Typography>
                        </Box>
                    )}

                    <LoadingButton
                        loading={memoLoader}
                        loadingPosition="start"
                        variant="contained"
                        onClick={() => handleSearch(status)}
                        startIcon={<SearchOutlinedIcon size="large" />}
                        disabled={status.length === 0}
                    >
                        Search
                    </LoadingButton>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            flexGrow: 1,
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            id="demo-customized-button"
                            aria-controls={open ? "demo-customized-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            variant="outlined"
                            onClick={handleClick}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid black",
                                borderRadius: "4px",
                                padding: "5px",
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src={colourchart}
                                alt="Color Scheme"
                                style={{
                                    height: "24px",
                                    width: "24px",
                                    marginRight: "5px",
                                }}
                            />
                            <KeyboardArrowDownIcon />
                        </Box>

                        <StyledMenu
                            id="demo-customized-menu"
                            MenuListProps={{
                                "aria-labelledby": "demo-customized-button",
                                style: {
                                    maxHeight: 250,
                                },
                            }} anchorEl={anchorEl}
                            open={open}
                            onClose={handleCloseButton}
                        >
                            {[
                                { label: "NEW", color: "#F9F08D" },
                                { label: "LAB", color: "#7EAEEE" },
                                { label: "RE-LAB", color: "#FCCD91" },
                                { label: "RE-CHECK", color: "#FFFFCC" },
                                { label: "RE-CHECK_SENT", color: "#B8ACF6" },
                                { label: "RE-CHECK_DONE", color: "#388BFF" },
                                { label: "MIX", color: "#E0E88C" },
                                { label: "AVAILABLE_APPROVAL_PENDING", color: "#FBDEDE" },
                                { label: "AVAILABLE", color: "#000000" },
                                { label: "HOLD", color: "#B6B9D6" },
                                { label: "MEMO_OUT", color: "#CAF7F6" },
                                { label: "SELL", color: "#CCFF99" },
                                { label: "SELL_SENT", color: "#F797D2" },
                                { label: "SOLD", color: "#26D4B9" },
                                { label: "SELL_CANCELLED", color: "#F59598" },
                                { label: "IN_TRANSIT", color: "#FEBD7D" },
                                { label: "AVAILABLE (IN_TRANSIT)", color: "#FEBD7D" },
                            ].map(({ label, color }) => (
                                <MenuItem key={label} onClick={handleCloseButton} disableRipple>
                                    <span
                                        style={{
                                            height: "15px",
                                            width: "15px",
                                            backgroundColor: color,
                                            borderRadius: 20,
                                            margin: 10,
                                        }}
                                    />
                                    {label}
                                </MenuItem>
                            ))}
                        </StyledMenu>
                    </Box>
                </Box>


                {!groupBy ? (
                    <div>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                height: "80vh",
                            }}
                        >
                            <DataGridPro
                                disableSelectionOnClick={true}
                                getRowHeight={() => "auto"}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                loading={memoLoader}
                                density="compact"
                                slots={{ toolbar: CustomToolbar }}
                                rows={rows}
                                columns={columns}
                                getRowId={(row) => row.uniqueId}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            labname: false,
                                            location: false,
                                            country: false,
                                        },
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>
                        <Box height={100}>
                            <TotalStockComponent data={rows} />
                        </Box>
                    </div>
                ) : (

                    <ThemeProvider theme={defaultMaterialTheme}>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .lavenderCell": {
                                    color: "#080808",
                                    backgroundColor: "#D8BFD8",
                                },
                                height: "70vh",
                            }}
                        >

                            <DataGridPro
                                disableRowSelectionOnClick={false}
                                density="compact"
                                columns={isReport ? ColumnJson.filter(column => (column.field !== "closememo" && column.field !== "issuememo")) :
                                    memoIssue_Permission.length > 0 ? ColumnJson : ColumnJson.filter(column => (column.field !== "issuememo"))}
                                rows={mainData}
                                getRowId={(row) => row.id}
                                loading={memoLoader}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    '& .MuiDataGrid-row': {
                                        whiteSpace: 'nowrap',
                                    },
                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                slots={{ toolbar: CustomToolbar }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: "id", sort: "desc" }],
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                // Below expandable row works but we do not want, so commenting as may/maynot require in future
                                // detailPanelExpandedRowIds={expandedRowIds}
                                // onDetailPanelExpandedRowIdsChange={expandedIdsChange}
                                getDetailPanelHeight={getDetailPanelHeight}
                                getDetailPanelContent={({ row }) => getDetailPanelContent(row, listData)}
                            // onRowsScrollEnd={handleRowsScrollEnd}
                            />
                        </Box>
                    </ThemeProvider>)}
            </Box>
        </div >
    );
};

export default MemoComponent;
